import styled from '@emotion/styled'
import { Flex } from '../atoms/Basics'
import { MediaQueries as Mq } from '../../styles/settings/theme'

const Container = styled.div`
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(34, 34, 34, 0.3),
    rgba(34, 34, 34, 0.7)
  );
  overflow: hidden;
  border-bottom: 1rem solid ${(props) => props.theme.colors.orange};
  margin-bottom: 5rem;
  position: relative;
`

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 5rem;
  ${Mq.md} {
    padding: 3rem;
  }
  ${Mq.xs} {
    padding: 2rem 1.25rem;
  }
`
const TitleBar = styled(Flex)`
  border-top: 2px solid ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.title};
  font-weight: 700;
  font-size: ${(props) => props.theme.fontSizes[2]};
  color: ${(props) => props.theme.colors.white};
  letter-spacing: 4px;
  text-transform: uppercase;
  padding-top: 1.25rem;
  flex-wrap: wrap;
  ${Mq.md} {
    font-size: ${(props) => props.theme.fontSizes[0]};
  }
`

const Title = styled.h1`
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.title};
  font-size: ${(props) => props.theme.fontSizes[8]};
  line-height: 1.2;
  text-align: center;
  padding-top: ${(props) => (props.top ? '10rem' : 0)};
  margin-bottom: 0;
  ${Mq.md} {
    font-size: 3rem;
  }
  ${Mq.xs} {
    font-size: 2.5rem;
  }
`
const IntroText = styled.p`
  max-width: 900px;
  margin: 8rem auto 1rem;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.fontSizes[5]};
  line-height: 1.85;
  ${Mq.md} {
    font-size: ${(props) => props.theme.fontSizes[3]};
  }
  ${Mq.md} {
    font-size: ${(props) => props.theme.fontSizes[2]};
  }
`
const HeroImg = styled.img`
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
  position: absolute;
  z-index: -1;
  ${Mq.md} {
    object-position: center 40%;
  }
  ${Mq.xs} {
    object-position: center center;
  }
`

const Attribution = styled.p`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
  z-index: 2;
  margin: 0;
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  background-color: rgba(34, 34, 34, 0.45);
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.fontSizes[0]};
  line-height: 1.4;

  ${Mq.md} {
    font-size: 0.75rem;
  }

  ${Mq.xs} {
    position: relative;
    left: auto;
    bottom: auto;
    margin: 0.5rem 0 0;
    display: inline-block;
  }
`

const Hero = ({ text }) => {
  const $ = window.WILDLABS_VARS
  const heroPhotoCredit =
    $.main_titles.photo_credit ||
    'Photo: Alasdair Davies, Penguin Watch, Oxford Brookes University'

  return (
    <Container>
      <HeroImg
        src={process.env.PUBLIC_URL + '/images/SOCT_hero.jpg'}
        alt="Alasdair Davies, Penguin Watch, Oxford Brookes University"
      />

      <HeroContent>
        <TitleBar justifyContent="space-between">
          <div>{$.main_titles.subtitle}</div>
          <div>{$.main_titles.date}</div>
        </TitleBar>
        <Title top={true}>{$.main_titles.title[0]}</Title>
        <Title>{$.main_titles.title[1]}</Title>
        <IntroText dangerouslySetInnerHTML={{ __html: text }} />
        <Attribution>{heroPhotoCredit}</Attribution>
      </HeroContent>
    </Container>
  )
}
export default Hero
